module.exports = __webpack_public_path__ + "static/media/MXChecks.4a9cb8f0.svg";